import { render, staticRenderFns } from "./message-item.vue?vue&type=template&id=73fcb26c&"
import script from "./message-item.vue?vue&type=script&lang=js&"
export * from "./message-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "message-item.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/base/message/message-item.vue
// module id = 142
// module chunks = 0